import React, { useState, useEffect } from "react";
import axios from "axios";
import { ApiBaseUrl } from '../constants/global';

const Pickupconfig = () => {
    /*const apiBaseUrl = "https://oz-config.thinkingbigbusiness.com.au";*/
    /*Initialize state using useState hook*/
    const [formData, setFormData] = useState({
        id: '',
        amount: '',
        path: '',
        zone: ''
    });
    const fetchInfo = () => {
        var pathval = document.getElementById('pickup-path').value;
        var postdata = {"path": pathval};
        const responce = axios
          .post(`${ApiBaseUrl}/getshipdata`, postdata)
          .then(response => {
                if (response.data.freeshippingdata && response.data.freeshippingdata.amount > 0) {
                    /*console.log("fetchInfo"+response.data);*/
                    setFormData({
                        id: response.data.freeshippingdata.id,
                        amount: response.data.freeshippingdata.amount,
                        path: response.data.freeshippingdata.path
                    });
                } else {
                    setFormData({id: '',amount: '', path: pathval, zone: ''});
                }
            })
            .catch(error => {
                setFormData({id: '',amount: '', path: pathval, zone: ''});
                console.log(error)
            });
        return responce;
    };
    useEffect(() => {
        fetchInfo();
    }, []);
    // Handle form input changes
    const handleChange = (event) => {
        const { name, value } = event.target;
        if (value && parseFloat(value) > 0){
            document.getElementById("pickup-sbt-btn").style.display = "inline-flex";
        } else {
            document.getElementById("pickup-sbt-btn").style.display = "none";
        }
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();
        var url;
        var html;
        var msgContainer = document.getElementById('page-message-pickup');
        if (formData.id !== "") {
            url = `${ApiBaseUrl}/updatepickup`;
            html = "<p>Pickup minimum amount successfully updated.</p>";
        } else {
            url = `${ApiBaseUrl}/addpickup`;
            html = "<p>Pickup minimum amount successfully added.</p>";
        }
        axios
            .post(url, formData)
            .then((response) => {
                /*console.log(response.data);*/
                setFormData({
                    id: response.data.freeshippingdata.id,
                    amount: response.data.freeshippingdata.amount,
                    path: response.data.freeshippingdata.path,
                    zone: response.data.freeshippingdata.zone
                });
                msgContainer.style.display = "block";
                msgContainer.innerHTML = html;
                msgContainer.classList.add("success");
                document.getElementById("pickup-sbt-btn").style.display = "none";
                setTimeout(function(){
                    msgContainer.style.display = "none";
                },10000);
            })
            .catch((error) => {
                msgContainer.style.display = "block";
                msgContainer.innerHTML = error;
                msgContainer.classList.add("error");
                document.getElementById("pickup-sbt-btn").style.display = "none";
                setTimeout(function(){
                    msgContainer.style.display = "none";
                },10000);
            });
    };
    return (
        <div className="config-main">
            <h2>Pickup Shipping Configuration</h2>
            <div>
                <div id="page-message-pickup" className="page-message"></div>
                <form onSubmit={handleSubmit}>
                    <div>
                        <input
                            type="hidden"
                            name="id"
                            placeholder="id"
                            defaultValue={formData.id}
                        />
                        <input
                            type="hidden"
                            name="path"
                            placeholder="path"
                            id="pickup-path"
                            defaultValue="pickup"
                        />
                    </div>
                    <div className="field">
                        <label htmlFor="amount">Minimum order amount for Pickup</label>
                        <input
                            type="number"
                            id="amount"
                            name="amount"
                            placeholder="Enter Value"
                            defaultValue={formData.amount}
                            onChange={handleChange}
                            max="9999"
                        />
                    </div>
                    <div>
                        <button id="pickup-sbt-btn" style={{display:"none"}}>Save</button>
                    </div>
                </form>
            </div>
        </div>
    );
};
 
export default Pickupconfig;